const LOCALE = 'en-GB';

export function formatDate(date: Date | string, opts?: { weekday?: boolean }): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  if (opts?.weekday) {
    options.weekday = 'long';
  }
  return d.toLocaleDateString(LOCALE, options);
}

export function formatTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit', hour12: false });
}

export function formatDateTime(date: Date | string, opts?: { weekday?: boolean }): string {
  return `${formatDate(date, opts)} ${formatTime(date)}`;
}

export function formatMonthYear(date: Date): string {
  return date.toLocaleDateString(LOCALE, { month: 'long', year: 'numeric' });
}

export function formatDateFull(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString(LOCALE, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
}
